import { createRouter, createWebHistory } from 'vue-router'
import CompanySelect from '@/components/CompanySelect.vue'
import TruckList from '@/components/TruckList.vue'

const routes = [
    { path: '/', name: 'CompanySelect', component: CompanySelect },
    { path: '/trucks/:companyId', name: 'TruckList', component: TruckList, props: true },
]

const router = createRouter({
    history: createWebHistory(),
    routes,
})

export default router
